<div class="with-floating-button">
    <div class="content">
        <page-header [hidden]="isInDetail" [title]="'workflow.roles.title' | translate" [listeItems]="listeTabItems">
        </page-header>

        <div [hidden]="selectedItem.code !== Onglets.ROLES">
            <roles-liste></roles-liste>
        </div>
    </div>
</div>